"use strict";

var _context2, _context3, _context4;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  extendURL: true,
  extendURLDeep: true,
  deleteParams: true,
  getParameterByName: true,
  queryStringToObject: true,
  toQueryString: true
};
_Object$defineProperty(exports, "deleteParams", {
  enumerable: true,
  get: function () {
    return _query.deleteParams;
  }
});
exports.extendURL = extendURL;
exports.extendURLDeep = extendURLDeep;
_Object$defineProperty(exports, "getParameterByName", {
  enumerable: true,
  get: function () {
    return _query.getParameterByName;
  }
});
_Object$defineProperty(exports, "queryStringToObject", {
  enumerable: true,
  get: function () {
    return _query.queryStringToObject;
  }
});
_Object$defineProperty(exports, "toQueryString", {
  enumerable: true,
  get: function () {
    return _query.toQueryString;
  }
});
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _query = require("./query");
var _pairs = require("../pairs");
var _history = require("./history");
_forEachInstanceProperty(_context2 = _Object$keys(_history)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _history[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _history[key];
    }
  });
});
var _combine = require("./combine");
_forEachInstanceProperty(_context3 = _Object$keys(_combine)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _combine[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _combine[key];
    }
  });
});
var _redirect = require("./redirect");
_forEachInstanceProperty(_context4 = _Object$keys(_redirect)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _redirect[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _redirect[key];
    }
  });
});
/**
 * Adds params to a URL, and converts it to an absolute path if the origin matches
 * the current origin.
 *
 * @param  {Object}  newParams
 * @param  {String}  [url=window.location.href]  url
 * @param  {Boolean} [deep=false] If the function should deeply merge values
 * @return {String}
 */
function extendURL(newParams = {}, url = window.location.href, deep = false) {
  if (typeof newParams !== 'object') {
    throw new Error(`Expected newParams to be an object, instead, got ${typeof newParams}`);
  }
  if (typeof url !== 'string') {
    throw new Error(`Expected url to be a string, instead, got ${typeof url}`);
  }
  const urlObj = new _url.default(url, window.location.href);
  const oldParams = (0, _query.queryStringToPairsArray)(urlObj.search);
  let newParamsPairsArray = (0, _pairs.isPairsArray)(newParams) ? newParams : (0, _query.objectToPairsArray)(newParams);
  newParamsPairsArray = (0, _pairs.mergePairs)(oldParams, newParamsPairsArray, deep);
  newParamsPairsArray = (0, _filter.default)(newParamsPairsArray).call(newParamsPairsArray, ({
    value
  }) => {
    var _context;
    return !(0, _isNil2.default)(value) || (0, _isString2.default)(value) && (0, _trim.default)(_context = value).call(_context) !== '';
  });
  urlObj.search = (0, _query.toQueryString)(newParamsPairsArray);
  if (urlObj.origin !== window.location.origin) {
    return urlObj.href;
  }
  return urlObj.pathname + urlObj.search;
}

/**
 * Adds params to a URL, and converts it to an absolute path if the origin matches
 * the current origin. This is an alias for extendURL that handles defaults for
 * the `url` and `deep` arguments.
 *
 * @param  {Object}  params
 * @param  {String}  [url=window.location.href]url
 * @return {String}
 */
function extendURLDeep(params, url = window.location.href) {
  return extendURL(params, url, true);
}